var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Details"},[_c('section',[_c('div',{staticClass:"x"},[(!_vm.project.modelId)?_c('div',{staticClass:"box"},[_c('h4',{staticClass:"title is-4"},[_vm._v("Not deployed yet. Run your AI model training first")])]):_c('div',{staticClass:"box"},[_c('DeployMonitor',{attrs:{"project":_vm.project}})],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }